import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { CommonService } from 'src/app/services/common.service';
import { DynamicFormsService } from 'src/app/services/dynamic-forms.service';

@Component({
  selector: 'app-custom-form',
  templateUrl: './custom-form.page.html',
  styleUrls: ['./custom-form.page.scss'],
})
export class CustomFormPage implements OnInit {
  @Input() case_id: string;
  @Input() form_slug: string;
  @Input() debtor_id: string;
  @Input() dpa_check: string;
  @Input() isFromPaymentPlan: boolean = false;
  jsonObject: any;
  jsonString: any;
  formConfig: any;
  loader;
  formObj;

  constructor(
    private commonService: CommonService,
    private dynamicFormsService: DynamicFormsService,
    private translate: TranslateService,
    private router: Router
  ) { }

  ngOnInit() {
    this.formConfig = {
      options: {
        alerts: {
          submitMessage: 'Thank you for submitting the form.'
        },
        errors: {
          message: 'Error while submitting the form. Please try again.'
        }
      }
    };
    this.getForm();
  }

  getForm(){
    this.commonService.showLoader(this.translate.instant('COMMON.LOADING'), 5000);
    this.dynamicFormsService.getForm(this.form_slug,this.case_id,this.debtor_id,this.dpa_check).subscribe(async(res)=>{

      this.commonService.dismissLoader();
      if(res['result']){
        if(res['data'].length > 0){
          this.setForm(res);
        }
      }else {
        this.commonService.showToast(res['message'],'danger');
      }
    });
  }

  setForm(obj){
    this.formObj = obj.data[0];
    this.jsonString = obj.data[0].content;
    this.jsonObject = JSON.parse(this.jsonString);
    if(this.jsonObject.display == 'form'){
			this.jsonObject.components.forEach( (component, index)=> {
        if(component.type == 'htmlelement'){
          var str = component.content;
          this.jsonObject.components[index].content = str.replace(/\\/g, '');
        }
      });
		} else if(this.jsonObject.display == 'wizard'){
      this.jsonObject.components.forEach( (page, index)=> {
        page.components.forEach((component,i) => {
          if(component.type == 'htmlelement'){
            var str = component.content;
            this.jsonObject.components[index].components[i].content = str.replace(/\\/g, '');
          }
        });
      });
		}

  }

  onRender(event) {
    // console.log(event);
  }
  onNext(event) {
    // console.log(event);
  }
  async onChange(event) {
    // console.log(event)
  }

  async onSubmit(event) {
    this.commonService.showLoader();
    let formHtml = '';
    if(this.form_slug.includes('sign')){
      const formContainer = document.getElementById('myFormio');
      const submitButton = formContainer.querySelector('.btn.btn-primary[type="submit"]') as HTMLElement;
      submitButton.remove();
      formHtml = formContainer.innerHTML;
    }
    
    // Add flag to indicate this is from payment plan if needed
    const payload = {
      data: event.data, 
      formHtml: formHtml,
      isFromPaymentPlan: this.isFromPaymentPlan,
      updateAccountStatus: this.isFromPaymentPlan && this.form_slug === 'iande' // Update status only for I&E form from payment plan
    };
    
    this.dynamicFormsService.saveFormData(this.form_slug, this.case_id, this.debtor_id, payload, this.dpa_check).subscribe(async (res) => {
      if(res['result']){
        this.jsonObject = {};
        // Show different success message for payment plan I&E submission
        if (this.isFromPaymentPlan && this.form_slug === 'iande') {
          this.commonService.showToast("Thanks. We'll review this and be in touch shortly. Your account has now been placed on hold.", 'success');
        } else {
          this.commonService.showToast(this.translate.instant('PAYMENT.PAYMENT_PLAN_OPTION.FORM.SUCCESS_MESSAGE'), 'success');
        }
      } else {
        this.jsonObject = {};
        this.commonService.showToast('Failed to Submit!','danger');
      }
      this.router.navigate(['/main']);
      this.commonService.dismissLoader();
    });
  }

}
